import React, { useState } from "react";
import icon from "../assets/images/home_page_images/Icon.svg";
import playstore from "../assets/images/home_page_images/playstore.svg";
import appstore from "../assets/images/home_page_images/appstore.svg";
import { ReactComponent as Hero } from "../assets/images/home_page_images/heroimage.svg";

const HeroSection = () => {
  const [removeHeroSection, setRemoveHeroSection] = useState(false);
  const handleRemoveHeroSection = () => {
    setRemoveHeroSection(true);
  };

  return (
    <>
      <div
        className={
          removeHeroSection ? "removeHeroSectionWrapper" : "heroSectionWrapper"
        }
      >
        <div className="row gx-4">
          <div className="col-md-6 col-12">
            <div className="heroSectionContent h-100">
              <div className="row">
                <div className="col-3">
                  <img src={icon} alt="" className="w-100" />
                </div>
                <div className="col-9">
                  <h2 className="title">Contact Mobile App</h2>
                  <p className="description">
                    Embarking on a journey where connections deepen, sharing
                    simplifies, and inspiration becomes the driving force.
                    Experience the future of networking with us, and together,
                    let’s “Connect. Share. Inspire.”
                  </p>

                  <div className="imagesWrapper d-flex align-items-center">
                    <div className="me-3">
                      <a
                        //href="https://play.google.com/store/apps/details?id=com.contactco.contactapp"
                        href="https://play.google.com/store/apps/details?id=com.contactco.contactapp"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={playstore} alt="" />
                      </a>
                    </div>
                    <div>
                      <a
                        //href="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913"
                        href="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={appstore} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="downloadBtnWrapper">
                <Link to="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913">
                  <button className="downloadBtn">Download App</button>
                </Link>
                <Link to="/help/aboutus">
                  <button className="cancelBtn">Learn More</button>
                </Link>
              </div> */}
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="heroSectionContentImage h-100">
              <Hero />
            </div>
          </div>
        </div>
        {/* <img
          src={remove}
          alt=""
          className={classes.heroSectionRemoveBtn}
          onClick={handleRemoveHeroSection}
        /> */}
      </div>
    </>
  );
};

export default HeroSection;
